import React, { useEffect, useState } from "react";
import packageJson from "../../package.json"; 

const VersionChecker = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  // FIXED: We don't need useState here. The version of the running code is constant.
  const currentVersion = packageJson.version; 

  useEffect(() => {
    const checkVersion = async () => {
      try {
        // We append a timestamp (?t=...) to the URL to force the browser 
        // to ignore its cache and get the actual latest file from the server.
        const response = await fetch(`/meta.json?t=${new Date().getTime()}`, {
          cache: "no-store",
        });
        
        if (!response.ok) return;

        const meta = await response.json();
        const latestVersion = meta.version;

        // Compare the server version (meta.json) with the running version (package.json)
        if (latestVersion && latestVersion !== currentVersion) {
          console.log(`Update available: ${currentVersion} -> ${latestVersion}`);
          setUpdateAvailable(true);
        }
      } catch (error) {
        console.error("Error checking version:", error);
      }
    };

    // Check immediately on load
    checkVersion();

    // Re-check every 5 minutes
    const interval = setInterval(checkVersion, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [currentVersion]);

  const handleRefresh = () => {
    // 1. Clear the browser cache to ensure we download the new bundle
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }
    // 2. Force a hard reload from the server
    window.location.reload(true);
  };

  if (!updateAvailable) return null;

  return (
    <div style={styles.banner}>
      <span>
        New Update Available! ({currentVersion} ➔ )
      </span>
      <button onClick={handleRefresh} style={styles.button}>
        Click to Refresh
      </button>
    </div>
  );
};

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    backgroundColor: "#ff9800",
    color: "white",
    textAlign: "center",
    padding: "12px",
    zIndex: 9999,
    boxShadow: "0 -2px 10px rgba(0,0,0,0.2)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "15px",
    fontFamily: "Arial, sans-serif",
  },
  button: {
    backgroundColor: "white",
    color: "#ff9800",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px",
  },
};

export default VersionChecker;